export enum JobProgressValue {
  Pending,
  InProgress,
  Complete,
}
export enum JobCategory {
  BinDelivery,
  MissedBin,
  CityClean,
  Unknown
}

export interface Job {
  id: string
  requestNumber: string
  type: string
  date: Date
  status: string
  category: JobCategory
  progress: JobProgressValue
  overdue?: Boolean
}
